import { ActionButton } from "@/components/action/action-button";
import { Plus } from "lucide-react";

interface AddVariantButtonProps {
  onClick: () => void;
}

export function AddVariantButton({ onClick }: AddVariantButtonProps) {
  return (
    <ActionButton onClick={onClick} variant="outline">
      <Plus />
      Add Variant
    </ActionButton>
  );
}
